import { API_ENDPOINTS } from "./config";

const QUERIES_API = API_ENDPOINTS.queries;

/**
 * POST /api/v1/queries
 * @param {{
 *   name: string,
 *   department: string,
 *   phone_number: string,
 *   email: string,
 *   message: string,
 * }} payload
 */
export const createQuery = async (payload) => {
  const response = await fetch(QUERIES_API, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ query: payload }),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const message =
      data?.message ||
      data?.error ||
      (Array.isArray(data?.errors) ? data.errors.join(", ") : null) ||
      `Failed to submit query (${response.status})`;
    throw new Error(message);
  }

  return data;
};
